/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ListAvailableSecrets200
} from './model/listAvailableSecrets200.js';

import type {
  ListAvailableSecretsParams
} from './model/listAvailableSecretsParams.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns names only, never values. Defaults to your own user secrets when ownerId is omitted; a team ownerId requires membership in that team.
 * @summary List the secret names available to attach to an agent.
 */
export const listAvailableSecrets = (
    params?: ListAvailableSecretsParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAvailableSecrets200>(
      {url: `/secrets/available`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAvailableSecretsQueryKey = (params?: ListAvailableSecretsParams,) => {
    return [
    `/secrets/available`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAvailableSecretsQueryOptions = <TData = Awaited<ReturnType<typeof listAvailableSecrets>>, TError = unknown>(params?: ListAvailableSecretsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAvailableSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAvailableSecretsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableSecrets>>> = ({ signal }) => listAvailableSecrets(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAvailableSecrets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAvailableSecretsQueryResult = NonNullable<Awaited<ReturnType<typeof listAvailableSecrets>>>
export type ListAvailableSecretsQueryError = unknown


/**
 * @summary List the secret names available to attach to an agent.
 */

export function useListAvailableSecrets<TData = Awaited<ReturnType<typeof listAvailableSecrets>>, TError = unknown>(
 params?: ListAvailableSecretsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAvailableSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAvailableSecretsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






